export default {
  retail: '智慧零售',
  retailDec:
    '在自动售货行业的演进历程中，商品识别技术不断突破创新：从早期的机械式结构，逐步发展为RFID射频识别、重力感应、静态视觉识别，再到融合动态视觉与云计算、动态视觉与边缘计算的智能识别方案。每一次技术迭代，都推动着行业向更智能、更高效的方向迈进。移远通信推出的OpenVending AI智能无人零售解决方案顺应发展，以先进的动态视觉与AI算力，精准捕捉商品信息，实现实时分析与决策，引领无人零售走向更高水平的智能与便捷。',
  retailTechnical:
    '摄像头的位置，一般来讲会配备两个摄像头，要么都在顶部，要么对角分布，但都在门所在的平面上。做货品识别时主要提取下图中绿色矩形框里的信息。现场的灯光、反光等因素可能会影响视频的质量，算法需具有足够的鲁棒性。',
  retailClientTitle: '',
  retailClientDec:
    '采用移远通信AI智能无人零售解决方案的兴元科技智能售货柜，凭借“动态视觉+边缘计算”的前沿核心能力，实现了精准商品识别和秒级响应速度，为消费者带来了“扫码开门、即拿即走”的无缝购物体验。',
  robot: '按摩机器人',
  robotDec:
    '久坐办公、运动损伤等导致肌肉劳损人群激增，传统按摩设备存在​​手法单一、无法精准适配个体需求​​的问题。通过AI大模型+柔性机器人技术，打造​​个性化、安全、智能化​​的按摩解决方案，覆盖家庭健康管理、医疗康复两大场景。​​智能痛点识别​​：结合热成像与压力传感器，定位肌肉僵硬、炎症区域。​​动态手法调节​​：仿人手揉捏、按压、拍打，力度与节奏实时适配用户状态。​健康风险预警​​：分析长期数据，提示颈椎病、腰椎间盘突出等疾病早期信号。​​人机自然交互​​：支持语音指令、APP远程控制，提供健康建议。',
  robotClientTitle: '德壹机器人',
  robotClientDec:
    'AI大模型赋予医疗机器人“类人认知”与“超级专家”能力，推动医疗从“经验驱动”转向“数据+知识双驱动”模式，最终实现精准化、普惠化、人性化医疗。',
  intelligent: '智慧分选',
  intelligentDec:
    'AI视觉检测技术正驱动传统分选模式向智能化方向革新。面对品类繁杂、形态非标化、环境敏感度高等行业痛点，传统人工分选存在效率低、标准不一致等局限，而基于深度学习的AI视觉系统展现出显著优势：结合动态光学分选装置，通过高精度图像识别算法，可实时解析果径纹理、色泽均匀度、机械损伤等外观特征，同步检测病虫害侵染、成熟度偏差等隐性缺陷。',
  intelligentTechnical:
    '移远通信色选解决方案面向工业物料管理行业开发，采用基于高通QCS6490平台的移远通信SG560D智能模组，并集成相机、光源和气枪等硬件。该解决方案通过视觉识别系统并结合机器视觉和边缘计算等能力，来改进工业物料的色选结果，并根据颜色和形状对物体进行自动化分选。其适用的色选范围包括大米、小麦、玉米、大豆、种子、坚果、盐等食品原料，塑料件、塑料颗粒、塑料瓶盖等塑料制品，以及石英石、石英砂、珍珠、大理石等矿物产品。搭载移远智能色选解决方案的色选机具体工作流程如下：物料通过料斗进入生产线，终端的视觉识别系统对物料进行监测，实时传输监测数据至AI系统；在AI系统中对合格物料的颜色、材质、尺寸等数据进行预先设定，符合标准的物料可进入下一质检流程；不符合标准的不良物料，将直接触发气枪吹离，使其远离生产线，进而完成色选等工作上述色选质检全程自动化，无需人工干涉。且终端还拥有自动调整设备工作参数、远程在线操作等功能，为提高自动化产线的性能、实现数据高效采集与传输、安全通信以及控制成本等方面创造了夯实的技术环境。',
  intelligentClientTitle: '色选',
  intelligentClientDec:
    '移远通信色选解决方案面向工业物料管理行业开发，采用基于高通QCS6490平台的移远通信SG560D智能模组，并集成相机、光源和气枪等硬件。该解决方案通过视觉识别系统并结合机器视觉和边缘计算等能力，来改进工业物料的色选结果，并根据颜色和形状对物体进行自动化分选。其适用的色选范围包括大米、小麦、玉米、大豆、种子、坚果、盐等食品原料，塑料件、塑料颗粒、塑料瓶盖等塑料制品，以及石英石、石英砂、珍珠、大理石等矿物产品。',
  scheme: '方案概述',
  technical: '技术方案',
  technical1: '搭载移远智能色选解决方案的色选具体工作流程如下：',
  technical2:
    '物料通过料斗进入生产线，终端的视觉识别系统对物料进行监测，实时传输监测数据至AI系统；',
  technical3:
    '在AI系统中对合格物料的颜色、材质、尺寸等数据进行预先设定，符合标准的物料可进入下一质检流程；',
  technical4:
    '不符合标准的不良物料，将直接触发气枪吹离，使其远离生产线，进而完成色选等工作',
  client: '相关案例',

  robot: '机器人行业',
  retailIndustry: '零售行业',
  sortIndustry: '智能分选行业',
  industry: '解决方案',
  pectorophony: '智能终端语音增强方案',
  businessBg: '业务背景',
  pectorophonyBg:
    '那些被噪音支配的崩溃瞬间<br>什么？大点声！我这根本听不清——<br>这些场景你一定不陌生：<br>1.对讲机灾难现场组队骑行中，对讲机里关键指令淹没在风声；工地上，对讲机里全是机械轰鸣，队友的指令根本听不清；KTV、演唱会安保对讲机里的互相嘶吼<br>2.行车记录仪困境开车时行车记录仪录下的对话，被胎噪、引擎声、透气开窗的风噪声淹没；<br>3.执法记录仪难题警察执法时，嘈杂的街道和人群的喧哗让记录仪录音变成无效数据移远AI语音增强方案，通过对采集声音的处理，一键屏蔽噪音，只保留你想要的人声。',
  case: '相关案例',
  pectorophonyScheme:
    '移远AI语音增强方案，对采集的音频流进行处理，先用信号处理简单噪音，再用AI降噪去掉复杂噪音，然后提升听感对非人声静音，最后通过自动增益自调整音量，实现清晰高质量的音频输出',
  pectorophonyApplyText1: '对讲机',
  pectorophonyApplyText2: '执法仪',
  pectorophonyCase:
    '项目描述：采用移远模组EC800M+AI音频增强算法，实现对讲机在工地、KTV等复杂场景的语音对讲应用，相比客户之前采用的音频DSP芯片成本降低一倍以上。',
  robrain: 'Robrain AI机器人解决方案',
  robrainBg:
    '具身智能需实时处理多模态传感器数据，但由于边缘设备算力有限，而依赖云端传输又会带来延迟，常导致机器人响应滞后或决策偏差。Robrain AI 机器人解决方案针对这一核心痛点——依托移远高算力AI模组与最新小型化大模型，结合模型压缩与微调等融合研发能力，突破实时响应瓶颈，真正实现端侧智能。在端云协同架构下，以端侧为主、云端为辅，确保敏感数据在本地完成处理，筑牢企业级安全屏障；即便在断网环境中，仍能维持85%以上的核心功能运行，助力机器人突破场景限制，实现更广泛的应用部署。',
  robrainScheme:
    '<h3 style="color: #1a1a1a">端云协同架构 赋能智能决策</h3><br>Robrain AI机器人解决方案深度融合多模态AI大模型，整合视觉、语音、文本等多模态数据输入，使机器人具备场景理解、文本识别与实时图像分析等核心能力，推动行业进入全感官交互时代。',
  robot: '机器人',
  robotCase:
    '目前，<b style="color: #1a1a1a">该方案已在逐际动力LimX Dynamics的明星产品——多形态双足机器人TRON 1上成功落地，有效攻克了AI模型定制、轻量化部署及低延迟交互响应等关键挑战</b>，推动机器人从“机械执行”跃升为“主动感知、智能思考、自然交流”的AI智能体。',
  openVend: 'OpenVending AI智能识别秤解决方案',
  openVendBg:
    '传统商超和生鲜零售店在结账环节存在多重效率瓶颈：商品需先人工称重打码，再排队收银，高峰期容易拥堵且耗时；人工操作依赖记忆商品代码，培训周期长且错误率高，易引发价格纠纷；称重与收银系统割裂，数据不同步，库存难以管控；同时，人工成本高，运营负担重，整体流程繁琐，难以满足消费者对便捷、精准购物的需求。<br>为解决这些痛点，移远通信推出了OpenVending AI智能识别秤解决方案，结合深度学习和AI视觉算法，实现0.1秒级商品自动识别和无感支付，显著提升结账效率，重塑传统称重流程。',
  openVendScheme:
    '<h3 style="color: #1a1a1a">解锁AI识别的“智慧之眼”</h3><br>OpenVending AI 解决方案搭载高精度摄像头采集商品图像，采用深度学习交叉编码器融合技术，精准提取商品形状、色泽、纹理等多维特征，与百万级商品图谱高效比对。方案可精准识别超 1000 个 SKU，识别准确率高达99%。<br><br>实际应用中，消费者将芒果等生鲜置于秤盘，系统通过捕捉商品颜色、大小、形状及表皮纹理等特征，结合数据库快速判定品类（如区分贵妃芒与水仙芒），无需人工输入 PLU 码，同步完成重量采集、单价匹配与总价计算，大幅提升结算效率。<br><br>商超及生鲜零售店部署该方案后，店员可脱离低效的称重计价工作，专注于包装、分拣、客户服务等核心环节，显著优化门店运营效率。同时，方案集成机器学习技术，通过持续学习分析历史数据不断强化预测能力，展现出卓越的智能化水平。',
  openVendScheme2:
    '<h3 style="color: #1a1a1a">0.1秒开启极速购物时代</h3><br>OpenVending已率先在移远SG560D 5G+AI智能模组上实现部署，经实测，商品识别与计价可在0.1秒内完成，效率远超传统方式。除了SG560D模组，该方案还兼容移远基于多款算力平台开发的多款AI智能模组，客户可根据零售业务规模和场地需求灵活选择，满足不同应用场景。',
  openVendScheme3:
    '<h3 style="color: #1a1a1a">智慧进化不止：灵活适配，持续升级</h3><br>历经海量数据的深度训练，移远OpenVending AI智能识别秤解决方案展现出卓越的模型泛化能力。同时，可灵活提供大、中、小等不同尺寸的模型，精准匹配各类实际应用场景需求。此外，方案支持模型的定期在线无缝升级，持续拓展可识别商品的种类边界，以满足市场的动态变化。',
  openVendCase:
    'AI智能识别秤不仅是提升零售效率的利器，更是重构“人-货-场”关系的关键数字化基础设施。从商超到农贸市场，从称重环节到全链路运营，这场由AI驱动的“秤上革命”正在重新定义零售行业的未来图景。作为全球物联网整体解决方案领域的领军者，移远通信将与行业客户同行，共同革新智慧零售体验的无限可能。',
  supermarkets: '商超',
  store: '生鲜零售店',
  tianbo: '天波智能识别秤',

  voiceAssistant: 'AI语音助手解决方案',
  voiceAssistantBg:
    'AI语音助手的卓越交互体验，离不开先进音频算法的支持。方案中，通过集成模组硬件，搭载全链路音频算法，融合云端大模型“智慧大脑“，让AI语音助手能够敏锐地“听到”与精准地“理解”用户。',
  voiceAssistantScheme:
    '在复杂环境中，音频降噪（ANS）算法有效过滤背景噪音，使玩具清晰捕捉用户声音；回声消除（AEC）算法确保玩具播放语音时，麦克风拾取到的喇叭声能有效去除，避免干扰；人声监测（VAD）算法精准判断语音活动，配合语音唤醒（KWS）算法，实现快速唤醒与指令识别，大幅提升交互效率。即使在嘈杂环境中，这些算法也能确保AI玩具精准识别用户语音指令，带来流畅的交互体验。例如，在家庭聚会等嘈杂场景下，AI玩具依然能被准确唤醒并理解指令。',
  voiceAssistantCaseTitle: '奥飞娱乐',
  voiceAssistantCaseDec:
    '玩点无限「AI 智趣喜羊羊 2.0」搭载移远4G版AI玩具整体解决方案，基于EC800M-CN 4G模组打造，让“喜羊羊”从静态玩偶蜕变为“能听会说、懂情绪、会成长”的AI智能体，重新定义潮玩行业的技术标杆。',
  voiceTerminal: '智能语音',
  Intelligent: '智能工业',
  massageRobot: '按摩机器人解决方案',
  intelligentVending: 'AI智能无人零售解决方案',
  terminalEnhancement: '终端增强方案',
  IntelligentSorting: '智能分选解决方案',
  toy: '毛绒玩具',
  base: '智能底座',
  learning: 'AI拍学机',
  desktop: '桌面机器人',
}
